var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-upload form-block"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"name":"file-uploader","type":"file","accept":_vm.format,"required":_vm.required},on:{"change":_vm.loadFileData}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }